import {
  Shimmer,
  ShimmerElementsGroup,
  ShimmerElementType,
  Stack,
} from '@fluentui/react';
import React, { JSX } from 'react';
import { useStyles } from './index.styles';

export const GroupHeader = (): JSX.Element => {
  const styles = useStyles();
  return (
    <div className={styles.container}>
      <ShimmerElementsGroup
        width="200px"
        shimmerElements={[
          { type: ShimmerElementType.line, height: 30, width: 200 },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          {
            type: ShimmerElementType.gap,
            height: 30,
            width: '100%',
          },
        ]}
      />
    </div>
  );
};

export const GroupRows = (): JSX.Element => {
  const styles = useStyles();
  return (
    <div className={styles.fullWidthContainer}>
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.line, height: 40, width: '100%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.gap, height: 50, width: '100%' },
        ]}
      />
    </div>
  );
};

export const ContactGroup: React.FC<{ totalShimmerRows: number }> = ({
  totalShimmerRows,
}) => {
  const styles = useStyles();
  const shimmerRowsArray = Array.from(Array(totalShimmerRows).keys());
  return (
    <>
      <Stack className={styles.containerPadding}>
        <Shimmer customElementsGroup={GroupHeader()} />
      </Stack>
      <Stack className={styles.rowPadding}>
        {shimmerRowsArray.length &&
          shimmerRowsArray.map((item) => {
            return <Shimmer key={item} customElementsGroup={GroupRows()} />;
          })}
      </Stack>
    </>
  );
};

export const ContactGroupShimmerView: React.FC = () => {
  const contactGroupArray = Array.from(Array(3).keys());
  return (
    <>
      {contactGroupArray.map((item) => {
        return <ContactGroup key={item} totalShimmerRows={3} />;
      })}
    </>
  );
};
